import { RUNTIME_BACKEND_URL } from '../lib/backendUrl';
import { create } from 'zustand';
import { isTokenValid } from './authStore';

const API = `${RUNTIME_BACKEND_URL}/api/hesap`;

// localStorage'dan yükleme sırasında token expire olmuş mu kontrol et
const _rawToken = localStorage.getItem('hesap_token');
const _initialToken = isTokenValid(_rawToken) ? _rawToken : null;
const _initialUser = _initialToken ? JSON.parse(localStorage.getItem('hesap_user') || 'null') : null;
if (!_initialToken && _rawToken) {
  // Expire olmuş — temizle
  localStorage.removeItem('hesap_token');
  localStorage.removeItem('hesap_user');
}

export const useHesapAuth = create((set, get) => ({
  token: _initialToken,
  user: _initialUser,

  login: async (email, password) => {
    const res = await fetch(`${API}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Giriş başarısız');
    localStorage.setItem('hesap_token', data.access_token);
    localStorage.setItem('hesap_user', JSON.stringify(data.user));
    set({ token: data.access_token, user: data.user });
  },

  loginWithGoogle: async (credential) => {
    const res = await fetch(`${API}/auth/google`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ credential })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || 'Google ile giriş başarısız');
    localStorage.setItem('hesap_token', data.access_token);
    localStorage.setItem('hesap_user', JSON.stringify(data.user));
    set({ token: data.access_token, user: data.user });
  },

  logout: () => {
    localStorage.removeItem('hesap_token');
    localStorage.removeItem('hesap_user');
    set({ token: null, user: null });
  },

  // Token expire olduysa otomatik logout
  checkAuthValid: () => {
    const t = get().token;
    if (t && !isTokenValid(t)) {
      localStorage.removeItem('hesap_token');
      localStorage.removeItem('hesap_user');
      set({ token: null, user: null });
      return false;
    }
    return !!t;
  },

  hasPermission: (perm) => {
    const user = get().user;
    if (!user) return false;
    if (user.role === 'admin') return true;
    return (user.permissions || []).includes(perm);
  },

  getHeaders: () => ({
    'Authorization': `Bearer ${get().token}`,
    'Content-Type': 'application/json'
  })
}));
